import { CustomProject } from 'models';
import generateRest from 'services/generateRest';

const CustomProjectService = generateRest<CustomProject>('custom_projects', {
  noEnvelope: true,
});

export default CustomProjectService;
